import React from 'react';

import { IconTile } from '@atlaskit/icon';
import type { GlyphProps } from '@atlaskit/icon/types';
import WhiteboardIcon from '@atlaskit/icon/core/whiteboard';

export const Whiteboard16Icon = (props: GlyphProps) => {
	const label = props.label || '';
	return (
		<IconTile
			key="whiteboard"
			label={label}
			appearance="tealBold"
			shape="square"
			size="16"
			icon={WhiteboardIcon}
			testId={props.testId}
		/>
	);
};
